// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__BTYUV","footer":"Form_footer__2GEgY"};